var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "10 9 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "thumb_up_selected copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.241,7.719 L14,1 L14.79,1.526 C16.028,2.352 16.398,4.002 15.633,5.278 L14,8 L21.781,8 C22.771,8 23.391,9.068 22.901,9.927 L16.46,21.244 C16.193,21.711 15.697,22 15.158,22 L9,22 C8.447,22 8,21.552 8,21 L8,8.37 C8,8.132 8.085,7.9 8.241,7.719 Z M3,8 L6,8 C6.553,8 7,8.447 7,9 L7,21 C7,21.55 6.55,22 6,22 L3,22 C2.448,22 2,21.552 2,21 L2,9 C2,8.45 2.45,8 3,8 Z",
    id: "path-1-thumbs-up"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sprite-Sheet-thumbs-up",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-Icon-Sheet-thumbs-up",
    transform: "translate(-637.000000, -381.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thumb_up-copy",
    transform: "translate(645.000000, 389.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_icons-thumbsUp"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-thumbs-up",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-thumbs-up"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask-thumbs-up",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1-thumbs-up"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_colors-white-thumbs-up",
    mask: "url(#mask-2-thumbs-up)",
    fill: "#202D3F",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "color-thumbs-up",
    points: "0 0 24 0 24 24 0 24"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs_up.2d389b3a.svg";
export { ForwardRef as ReactComponent };